import { render, staticRenderFns } from "./DialogAdminAccess.vue?vue&type=template&id=694ea3f9&scoped=true&"
import script from "./DialogAdminAccess.vue?vue&type=script&lang=js&"
export * from "./DialogAdminAccess.vue?vue&type=script&lang=js&"
import style0 from "./DialogAdminAccess.vue?vue&type=style&index=0&id=694ea3f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694ea3f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
